export default "__VITE_ASSET__DicW0dNK__"